import React, { Fragment, createRef, useEffect } from 'react';
import PropTypes from 'prop-types';
import { Row, Col } from 'reactstrap';
import BootstrapTable from 'react-bootstrap-table-next';
import paginationFactory, { PaginationProvider, PaginationListStandalone } from 'react-bootstrap-table2-paginator';
import ToolkitProvider, { Search } from 'react-bootstrap-table2-toolkit';
import FalconCardHeader from '../../components/common/FalconCardHeader';
// import ButtonIcon from '../../components/common/ButtonIcon';
import './headerstyle.css';
import './customtooltipstyle.css';

import BackButton from './BackButton';

const { SearchBar, ClearSearchButton } = Search;

const SelectRowInput = ({ indeterminate, rowIndex, ...rest }) => {
  return (
    <div className="custom-control custom-checkbox">
      <input
        className="custom-control-input"
        {...rest}
        onChange={() => {}}
        ref={input => {
          if (input) input.indeterminate = indeterminate;
        }}
      />
      <label className="custom-control-label" />
    </div>
  );
};

// function ItemToolTip(props) {
//   if (!props.tooltiptext) {
//     return null; // No renderizar nada si tooltiptext no tiene valor
//   }

//   return (
//     <Tooltip placement={props.placement} isOpen={props.isOpen} target={props.target} toggle={props.toggle}>
//       {props.tooltiptext}
//     </Tooltip>
//   );
// }

export default class PageFilterableTable extends React.Component {
  table = createRef();
  selectRow = onSelect => ({
    mode: 'checkbox',
    columnClasses: 'py-2 align-middle',
    clickToSelect: false,
    selectionHeaderRenderer: ({ mode, ...rest }) => <SelectRowInput type="checkbox" {...rest} />,
    selectionRenderer: ({ mode, ...rest }) => <SelectRowInput type={mode} {...rest} />,
    headerColumnStyle: { border: 0, verticalAlign: 'middle' },
    selectColumnStyle: { border: 0, verticalAlign: 'middle' },
    onSelect: onSelect,
    onSelectAll: onSelect
  });
  onSelect = () => {
    setImmediate(() => {
      this.setIsSelected(
        !!this.table.current.selectionContext.selected.length,
        this.table.current.selectionContext.selected
      );
    });
  };
  constructor(props) {
    super(props);
    this.handle_OnNewClick = this.handle_OnNewClick.bind(this);
    this.setIsSelected = this.setIsSelected.bind(this);
  }

  handle_OnNewClick() {
    this.props.handle_OnNewClick();
  }

  setIsSelected(isSelected, selectedRows) {
    this.props.setIsSelected(isSelected, selectedRows);
  }

  render() {
    const paginationOption = {
      custom: true,
      paginationSize: 4,
      pageStartIndex: 1,
      firstPageText: 'First',
      prePageText: 'Back',
      nextPageText: 'Next',
      lastPageText: 'Last',
      nextPageTitle: 'First page',
      prePageTitle: 'Pre page',
      firstPageTitle: 'Next page',
      lastPageTitle: 'Last page',
      showTotal: true,
      totalSize: this.props.data ? this.props.data.length : 0,
      sizePerPage: this.props.sizePerPage,
      hidePageListOnlyOnePage: true,
      page: this.props.page,
      onPageChange: this.props.onPageChange
    };

    const tableOption = {
      title: this.props.title,
      keyField: this.props.keyField,
      columns: this.props.columns,
      data: this.props.data,
      setSearchResult: this.props.setSearchResult,
      useSelectRow: this.props.useSelectRow,
      enableNewButton: this.props.enableNewButton,
      disableNewButton: this.props.disableNewButton,
      ownerKeyValue: this.props.ownerKeyValue,
      defaultSearch: this.props.defaultSearch,
      leftActionButtons: this.props.leftActionButtons,
      rightActionButtons: this.props.rightActionButtons,
      setSearchText: this.props.setSearchText,
      setCompanyFilter: this.props.setCompanyFilter,
      newbuttontooltiptext: this.props.newbuttontooltiptext
    };

    const Maintoolkit = ({ toolkitprops, paginationTableProps }) => {
      // tableOption.setSearchResult(newResult);
      useEffect(() => {
        if (tableOption.defaultSearch !== toolkitprops.searchProps.searchText)
          if (tableOption.setCompanyFilter) {
            tableOption.setCompanyFilter(toolkitprops.searchProps.searchText);
          }
      }, [toolkitprops.searchProps.searchText]);

      const actionRow = (
        <Row id="actionrow">
          {tableOption.data.length > 0 && (
            <Fragment>
              {tableOption.leftActionButtons && tableOption.leftActionButtons}
              <div id="spec_searchbar_local" className="ml-auto d-flex align-items-center">
                <SearchBar className="rounded-pill search-input" {...toolkitprops.searchProps} />
                <ClearSearchButton
                  tableId="agencytable"
                  {...toolkitprops.searchProps}
                  className="btn-falcon-default d-inline ml-2"
                  color="falcon-default"
                />
              </div>
            </Fragment>
          )}
          {tableOption.ownerKeyValue !== 0 && <BackButton className="ml-2" />}
          {tableOption.enableNewButton === true ? (
            <>
              <button
                type="button"
                id="newgeneralbutton_1"
                className="d-inline ml-2 btn btn-falcon-default btn-sm customtooltip"
                onClick={this.handle_OnNewClick}
                disabled={tableOption.disableNewButton === true}
              >
                <svg
                  aria-hidden="true"
                  focusable="false"
                  data-prefix="fas"
                  data-icon="plus"
                  className="svg-inline--fa fa-plus fa-w-14 mr-1"
                  role="img"
                  xmlns="http://www.w3.org/2000/svg"
                  viewBox="0 0 448 512"
                  style={{ transformOrigin: '0.4375em 0.625em' }}
                >
                  <g transform="translate(224 256)">
                    <g transform="translate(0, 64)  scale(0.8125, 0.8125)  rotate(0 0 0)">
                      <path
                        fill="currentColor"
                        d="M416 208H272V64c0-17.67-14.33-32-32-32h-32c-17.67 0-32 14.33-32 32v144H32c-17.67 0-32 14.33-32 32v32c0 17.67 14.33 32 32 32h144v144c0 17.67 14.33 32 32 32h32c17.67 0 32-14.33 32-32V304h144c17.67 0 32-14.33 32-32v-32c0-17.67-14.33-32-32-32z"
                        transform="translate(-224 -256)"
                      />
                    </g>
                  </g>
                </svg>
                New
                {tableOption.newbuttontooltiptext && (
                  <span className="customtooltiptext left">{tableOption.newbuttontooltiptext}</span>
                )}
              </button>
            </>
          ) : (
            ''
          )}
          {tableOption.rightActionButtons && tableOption.rightActionButtons}
        </Row>
      );

      return (
        <Fragment>
          {tableOption.title ? (
            <FalconCardHeader title={tableOption.title} light={false}>
              {actionRow}
            </FalconCardHeader>
          ) : (
            <div className="nav-search-row" style={{ padding: '4px 8px' }}>
              {tableOption.data.length > 0 && (
                <div style={{ display: 'flex', alignItems: 'center', gap: '8px', justifyContent: 'flex-end' }}>
                  <div style={{ width: '200px', flexShrink: 0 }}>
                    <SearchBar className="rounded-pill search-input" {...toolkitprops.searchProps} />
                  </div>
                  <ClearSearchButton
                    tableId="agencytable"
                    {...toolkitprops.searchProps}
                    className="btn-falcon-default btn-sm"
                    color="falcon-default"
                  />
                </div>
              )}
            </div>
          )}

          {tableOption.useSelectRow ? (
            <BootstrapTable
              striped
              hover
              ref={this.table}
              keyField={tableOption.keyField}
              selectRow={this.selectRow(this.onSelect)}
              noDataIndication={'no results found'}
              bordered={false}
              classes="table-sm fs--1 border-bottom border-200 mb-0"
              rowClasses="btn-reveal-trigger border-top border-200"
              headerClasses="bg-200 text-900 border-y border-200"
              rowEvents={this.props.rowEvents}
              rowStyle={this.props.rowStyle}
              sort={this.props.defaultSort}
              {...toolkitprops.baseProps}
              {...paginationTableProps}
              bootstrap4
            />
          ) : (
            <BootstrapTable
              striped
              hover
              ref={this.table}
              keyField={tableOption.keyField}
              noDataIndication={'no results found'}
              bordered={false}
              classes="table-sm fs--1 border-bottom border-200 mb-0"
              rowClasses="btn-reveal-trigger border-top border-200"
              headerClasses="bg-200 text-900 border-y border-200"
              rowEvents={this.props.rowEvents}
              rowStyle={this.props.rowStyle}
              sort={this.props.defaultSort}
              {...toolkitprops.baseProps}
              {...paginationTableProps}
              bootstrap4
            />
          )}
        </Fragment>
      );
    };

    return (
      <Fragment>
        <PaginationProvider pagination={paginationFactory(paginationOption)}>
          {({ paginationProps, paginationTableProps }) => {
            const afterSearch = newResult => {
              tableOption.setSearchResult(newResult);
            };

            return (
              <Fragment>
                <ToolkitProvider
                  keyField={tableOption.keyField}
                  columns={tableOption.columns}
                  data={tableOption.data}
                  // search={{ afterSearch }}
                  search={{
                    afterSearch: afterSearch,
                    defaultSearch: tableOption.defaultSearch
                  }}
                >
                  {toolkitprops => (
                    <Maintoolkit toolkitprops={toolkitprops} paginationTableProps={paginationTableProps} />
                  )}
                </ToolkitProvider>
                <Row noGutters className="px-1 py-3 flex-center">
                  <Col xs="auto">
                    <PaginationListStandalone {...paginationProps} />
                  </Col>
                </Row>
              </Fragment>
            );
          }}
        </PaginationProvider>
      </Fragment>
    );
  }
}

PageFilterableTable.defaultProps = {
  title: '',
  ownerKeyValue: 0,
  useSelectRow: false,
  enableNewButton: true,
  handle_OnNewClick: () => {},
  sizePerPage: 10,
  setSearchResult: () => {},
  defaultSort: null,
  rowEvents: null,
  rowStyle: null,
  defaultSearch: '',
  setSearchText: () => {},
  page: 1,
  onPageChange: null,
  newbuttontooltiptext: ''
};

PageFilterableTable.propTypes = {
  title: PropTypes.string,
  datalist: PropTypes.array,
  columns: PropTypes.array,
  handle_OnNewClick: PropTypes.func,
  setIsSelected: PropTypes.func,
  keyField: PropTypes.string,
  ownerKeyValue: PropTypes.number,
  useSelectRow: PropTypes.bool,
  enableNewButton: PropTypes.bool,
  sizePerPage: PropTypes.number,
  setSearchResult: PropTypes.func,
  defaultSort: PropTypes.object,
  rowEvents: PropTypes.object,
  rowStyle: PropTypes.func,
  defaultSearch: PropTypes.string,
  setSearchText: PropTypes.func,
  page: PropTypes.number,
  onPageChange: PropTypes.func,
  newbuttontooltiptext: PropTypes.string
};
